import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-blocked-nip-add-dialog',
  templateUrl: './blocked-nip-add-dialog.component.html',
  styleUrls: ['./blocked-nip-add-dialog.component.scss']
})
export class BlockedNipAddDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BlockedNipAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BlockedNipAddDialogComponent,
  ) {
  }

  ngOnInit(): void {
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
